import React, { useState } from 'react';

interface PasswordGateProps {
  onSubmit: (password: string) => void;
  error?: string;
  loading?: boolean;
}

export function PasswordGate({ onSubmit, error, loading }: PasswordGateProps) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password.trim());
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-50 to-pink-50 px-4">
      <div className="w-full max-w-sm animate-scale-in">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full gradient-bg flex items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 font-display mb-2">
            Enter Password
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            This event is password protected. Enter the password to view.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field text-center text-lg tracking-wide"
              placeholder="Event password"
              autoFocus
              autoComplete="off"
            />

            {error && (
              <p className="text-sm text-red-600 animate-slide-down">{error}</p>
            )}

            <button
              type="submit"
              disabled={!password.trim() || loading}
              className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Checking...' : 'Enter'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          Powered by About Bloody Time!
        </p>
      </div>
    </div>
  );
}
